var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMtnLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MTN_Logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960,320c-353.46,0-640,143.27-640,320S606.54,960,960,960s640-143.27,640-320S1313.46,320,960,320Zm0,589.48c-325.56,0-589.48-120.65-589.48-269.48S634.44,370.52,960,370.52,1549.48,491.17,1549.48,640,1285.56,909.48,960,909.48ZM879.29,583.86V533.33h180.55v50.53h-65V746.67H944.3V583.86Zm398.49-50.53V746.67h-50.52l-91.63-127v127h-50.52V533.33h50.52l91.63,127v-127ZM640.72,746.67V533.33h50.52l56.13,86.34,56.13-86.34H854V746.67H803.5V626L765.18,684.9H729.56L691.24,626V746.67Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Digital_clear_space"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,1280c176.73,0,320-286.54,320-640S176.73,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1920,0c-176.73,0-320,286.54-320,640s143.27,640,320,640"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1600,1280c0-176.73-286.54-320-640-320s-640,143.27-640,320"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320,0c0,176.73,286.54,320,640,320S1600,176.73,1600,0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1920,
    height: 1280
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtnLogo);
export default __webpack_public_path__ + "static/media/mtn-logo.83822b23828ed37ba9904a2d9372dcaf.svg";
export { ForwardRef as ReactComponent };